import { useRef } from "react";
import { ChevronLeft, Upload } from "lucide-react";
import type { GameConsole } from "../consoles";

interface RomUploadProps {
  console: GameConsole;
  onPick: (file: File) => void;
  onBack: () => void;
}

export function RomUpload({ console, onPick, onBack }: RomUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleFile(file: File | undefined) {
    if (!file) return;
    onPick(file);
  }

  return (
    <div className="flex items-center justify-center h-full p-6">
      <div className="w-full max-w-md text-center">
        <button
          type="button"
          onClick={onBack}
          className="text-text-secondary hover:text-text-primary text-sm transition-colors mb-6 inline-flex items-center gap-1"
        >
          <ChevronLeft size={16} strokeWidth={1.75} aria-hidden />
          consoles
        </button>

        <div className="flex flex-col items-center mb-6">
          <span className="text-4xl leading-none mb-2">{console.emoji}</span>
          <h1 className="text-2xl font-semibold text-text-primary">{console.name}</h1>
        </div>

        <p className="text-text-secondary text-sm mb-6">
          Bring your own ROM — it stays in your browser and is never uploaded.
        </p>

        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="w-full rounded-xl border-2 border-dashed border-border bg-surface-2 hover:bg-surface-3 hover:border-[#5865F2] transition-colors px-6 py-12 cursor-pointer focus:outline-none focus:border-[#5865F2]"
        >
          <Upload size={36} strokeWidth={1.5} className="mx-auto mb-3" style={{ color: "#5865F2" }} aria-hidden />
          <div className="text-text-primary font-medium">Choose a ROM</div>
          <div className="text-text-muted text-xs mt-1">{console.accept}</div>
        </button>

        <input
          ref={inputRef}
          type="file"
          accept={console.accept}
          className="hidden"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>
    </div>
  );
}
